import { Stack } from '@mui/material';
import { formatCurrency } from 'utils';
import { Nullable } from 'global';
import { DealBuilderQuote } from '../../../../api';
import { SummaryCard } from './SummaryCard';
import { QuoteCalcViewModel } from 'modules/quote';

interface Props {
  quote: Nullable<DealBuilderQuote>;
  priceCalc: Nullable<QuoteCalcViewModel>;
}

export const SummaryCards = ({ quote, priceCalc }: Props) => {
  const itemCount = quote?.equipment?.length ?? 0;

  return (
    <Stack direction="row" gap={1.5}>
      <SummaryCard
        label="Equipment Total"
        value={formatCurrency(priceCalc?.netFinanceAmount?.hardCost, true)}
        caption={`${itemCount} item${itemCount === 1 ? '' : 's'}`}
        type="equipmentTotal"
      />
      <SummaryCard
        label="Customer Deposit"
        value={formatCurrency(priceCalc?.netFinanceAmount?.deposit, true)}
        type="deposit"
      />
      <SummaryCard
        label="Balance Due"
        value={formatCurrency(priceCalc?.netFinanceAmount?.balanceToFinance, true)}
        type="balanceDue"
      />
      {priceCalc?.netFinanceAmount?.estimatedMonthlyPayment?.amount != null && (
        <SummaryCard
          label="Estimated Monthly Payment"
          value={formatCurrency(priceCalc?.netFinanceAmount?.estimatedMonthlyPayment?.amount, true)}
          type="estimatedPayment"
        />
      )}
    </Stack>
  );
};
